// @flow
import type { ID } from "data/enums/types"

export default {
  // Placeholder link due to the real link no longer existing but where we want
  // to keep the unused component mostly intact.
  // See: https://app.clubhouse.io/awayco/story/1238/user-app-ui-changes
  placeholder: "/",

  // non-auth
  home: "/",
  explore: "/explore",
  terms: "/terms",
  privacy: "https://www.awayco.com/privacy",
  registerYourStore: "/register-your-store",
  welcomeToAwayco: "/welcome-to-awayco",
  awayco: "https://www.awayco.com",
  debug: "/debug",

  // auth only
  reservations: "/reservations",
  reservation: (id: ID) => `/reservation/${id}`,
  reserveProduct: (productVariantId: ID, affiliateId: ID) =>
    `/product/${productVariantId}/${affiliateId}/checkout`,
  shoppingBasket: "/shopping-basket",

  account: {
    // Placeholder link due to the real link no longer existing but where we want
    // to keep the unused component mostly intact
    // See: https://app.clubhouse.io/awayco/story/1238/user-app-ui-changes
    placeholder: "/account",

    index: "/account",
    password: "/account/password",
    payments: "/account/payments",
    deleteAccount: "/account/delete-account",
  },

  search: "/search",
  products: "/products",
  product: (productId: ID, affiliateId: ID) =>
    `/product/${productId}/${affiliateId}`,
  cart: (productVariantId: ID, affiliateId: ID) =>
    `/product/${productVariantId}/${affiliateId}/cart`,
  affiliate: (id: ID) => `/affiliate/${id}`,
  brand: (name: string) => `/brand/${name}`,
  resetPassword: "/reset-password",
}



// WEBPACK FOOTER //
// ./src/data/router/urls.js